export const MUTATION_KEYS = {
    LOGIN: 'login'
} as const
